// extracted by mini-css-extract-plugin
export default {"paymentSection":"N2-z"};